function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Checked({
  width = 23,
  height = 15,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.521.346a1.184 1.184 0 00-1.674 0L9.051 12.143l-7.06-7.06A1.184 1.184 0 00.319 6.759l7.896 7.896a1.184 1.184 0 001.674 0L22.52 2.02a1.184 1.184 0 000-1.674z",
    fill: "#000"
  }));
}
//# sourceMappingURL=Checked.js.map